<template>
  <button
    :class="[
      'uppercase cursor-pointer hover:text-pink transition-colors',
      { 'text-burgundy': dark },
    ]"
    @click.stop="$i18n.locale = toLang"
  >
    {{ toLang }}
  </button>
</template>

<script lang="ts">
export default {
  name: 'LangSwitch',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    toLang() {
      return this.$i18n.locale === 'fr' ? 'en' : 'fr'
    },
  },
}
</script>
